const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export async function GetAssignacions() {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/assignacions`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        });

        if (response.ok) {
            return await response.json();
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching assignacions:', error);
        return [];
    }
}

export async function PostAssignacio(data: { id_alumne: number, id_empresa: number, estat: number }) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/assignacions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(data)
        });
        return response.ok;
    } catch (error) {
        console.error('Error posting assignacio:', error);
        return false;
    }
}

export async function PutAssignacioEstat(data: { id: number, estat_nou: number, observacions: string, usuari_canvi: number, data_inici?: string, data_fi?: string }) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/assignacions/estat`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(data)
        });
        return response.ok;
    } catch (error) {
        console.error('Error updating assignacio status:', error);
        return false;
    }
}
